import "./baseConfig/font.css.ts.vanilla.mjs";
import "./popup.css.ts.vanilla.mjs";
var r = "p273__popup-896e_fc936e419__1t09rs50";
export {
  r as popupStyle
};
//# sourceMappingURL=popup.mjs.map
